/**
 * Mueve el nodo del ghost shirt (design-preview-component) dentro o fuera de
 * .product-configurator__fields según el ancho de pantalla — no hay forma
 * 100% confiable cross-browser de lograr el layout de desktop (ghost shirt
 * como sticky sidebar de ancho independiente, sin que su alto infle las
 * filas de los 6 campos) y el orden intercalado de mobile (ghost shirt
 * entre "QR link" y "Price") al mismo tiempo con solo CSS — ver el
 * comentario en sections/product-configurator.liquid.
 *
 * Mueve el mismo nodo del DOM (no clona ni re-renderiza), así que
 * design-preview.js no pierde su estado ni sus listeners.
 *
 * Se carga sin type="module" a propósito: el script tag ya está posicionado
 * en el HTML justo después de .product-configurator__grid, así que un
 * script clásico (sin module/defer/async) ejecuta de forma síncrona ahí
 * mismo, moviendo el DOM antes de que el navegador pinte la sección — un
 * module script es diferido por spec y dejaba pintar el layout inicial
 * (con el ghost shirt sin mover) antes de correr, causando el flash de
 * Size/Shirt color estirados en WebKit/iOS hasta el próximo reflow. Todo el
 * archivo va envuelto en un IIFE para no declarar nada en el scope global,
 * igual que el script equivalente en layout/theme.liquid.
 */
(function () {
  const DESKTOP_QUERY = '(min-width: 750px)';

  function reposition(fieldsEl, previewEl, linkEl, desktopQuery) {
    const gridEl = fieldsEl.parentElement;
    if (!gridEl) return;

    // Skip the DOM mutation entirely when the node is already where it needs
    // to be (true on every initial mobile load, since the server already
    // renders it there) — insertBefore/after() is a real remove+insert even
    // when the end position is unchanged, and some WebKit versions leave
    // nearby flex/grid layouts (e.g. the Size buttons) with stale computed
    // sizes until the next interaction-triggered reflow.
    if (desktopQuery.matches) {
      if (previewEl.nextElementSibling !== fieldsEl) {
        gridEl.insertBefore(previewEl, fieldsEl);
      }
    } else if (previewEl.previousElementSibling !== linkEl) {
      linkEl.after(previewEl);
    }
  }

  function initConfigurator(gridEl) {
    const fieldsEl = gridEl.querySelector('.product-configurator__fields');
    const previewEl = gridEl.querySelector("[id$='__configurator-preview']");
    const linkEl = fieldsEl && fieldsEl.querySelector("[id$='__configurator-link']");
    if (!fieldsEl || !previewEl || !linkEl) return;

    const desktopQuery = window.matchMedia(DESKTOP_QUERY);
    reposition(fieldsEl, previewEl, linkEl, desktopQuery);
    desktopQuery.addEventListener('change', () => reposition(fieldsEl, previewEl, linkEl, desktopQuery));
  }

  document.querySelectorAll('.product-configurator__grid').forEach(initConfigurator);
})();
